import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const CompanyNews = ({ news }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-6 lg:p-8">
      <h2 className="text-2xl font-bold text-foreground mb-6">Recent News & Updates</h2>
      <div className="space-y-6">
        {news?.map((item) => (
          <div key={item?.id} className="flex flex-col sm:flex-row gap-6 p-6 bg-muted/50 border border-border rounded-lg hover:border-primary/50 transition-smooth">
            <div className="w-full sm:w-48 h-48 sm:h-32 rounded-lg overflow-hidden flex-shrink-0">
              <Image
                src={item?.image}
                alt={item?.imageAlt}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="flex-1">
              <div className="flex items-center gap-3 mb-3">
                <span className={`px-3 py-1 text-xs font-medium rounded-full ${
                  item?.category === 'Award' ? 'bg-warning/10 text-warning' :
                  item?.category === 'Expansion' ? 'bg-success/10 text-success' :
                  item?.category === 'Product'? 'bg-primary/10 text-primary' : 'bg-accent/10 text-accent'
                }`}>
                  {item?.category}
                </span>
                <span className="text-sm text-muted-foreground">{item?.date}</span>
              </div>
              <h3 className="text-lg font-semibold text-foreground mb-2 hover:text-primary cursor-pointer transition-smooth">
                {item?.title}
              </h3>
              <p className="text-muted-foreground mb-4 line-clamp-2">{item?.description}</p>
              <button className="flex items-center gap-2 text-sm text-primary font-medium hover:underline">
                <span>Read More</span>
                <Icon name="ArrowRight" size={16} />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CompanyNews;